import { render, staticRenderFns } from "./activity_discount_timer.vue?vue&type=template&id=04937a00&"
import script from "./activity_discount_timer.vue?vue&type=script&lang=js&"
export * from "./activity_discount_timer.vue?vue&type=script&lang=js&"
import style0 from "./activity_discount_timer.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports